export const CSS = {
  handle: "handle",
  handleActivated: "handle--activated",
};

export const ICONS = {
  drag: "drag",
};
